import React from 'react';
import { getUrlParameterText } from "./urlTracking";
import "./quote.css";
import { BrandHeader, PageHero } from "./BrandChrome";

const getTrackingUrl = (tracking) => {
  if (typeof tracking !== "string") return "";

  const markdownLink = tracking.match(/\((https?:\/\/[^)\s]+)\)/i);
  const candidate = markdownLink ? markdownLink[1] : tracking.trim();

  try {
    const url = new URL(candidate);
    return url.protocol === "https:" && url.hostname === "tracking.fhbrundle.co.uk"
      ? url.href
      : "";
  } catch {
    return "";
  }
};

const formatTimelineDate = (value) => {
  if (!value) return "—";

  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "2-digit"
  }).format(date);
};

const TimelineStep = ({ label, value }) => (
  <li className={`invoice-timeline-step${value ? "" : " is-empty"}`}>
    <span className="invoice-timeline-dot" aria-hidden="true" />
    <span className="invoice-timeline-label">{label}</span>
    {value ? (
      <time className="invoice-timeline-date" dateTime={value}>
        {formatTimelineDate(value)}
      </time>
    ) : (
      <span className="invoice-timeline-date">—</span>
    )}
  </li>
);

export default class PaymentRef extends React.Component {
  constructor(props) {
    super(props);
    const initialPaymentRef = typeof window !== "undefined"
      ? (new URLSearchParams(window.location.search).get("ref") || "").trim()
      : "";

    this.state = {
      paymentRef: initialPaymentRef,
      submittedPaymentRef: '',
      refType: '',
      refCust:{},
      refData: [],
      isLoading: Boolean(initialPaymentRef),
      delAddr: null,
      invAddr: null,
      showOverLimitMessage: false,
      quoteAccepted: false,
      showDeclineModal: false,
      declineFeedback: '',
      declined: false,
      editableTheirRef: ''
    };
  }

  handleChange = (e) => {
    this.setState({ paymentRef: e.target.value });
  };

  componentDidMount() {
    const ref = this.state.paymentRef;

    if (ref !== "") {
      this.handleSubmit({ preventDefault: () => {} });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { paymentRef } = this.state;

    if (paymentRef.trim() === '') {
      alert('Please enter a valid reference');
      return;
    }

    this.setState({
      isLoading: true,
      refData: [],
      refCust: {},
      showOverLimitMessage: false
    });

    try {
      const formData = new FormData();
      const formData2 = new FormData();
      formData.append('reference', paymentRef);

      const response = await fetch('https://payments.fhbrundle.co.uk/api?cmd=ref_lookup', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data && data.ref_type && data.ref_data) {
        const theirRef = Array.isArray(data.ref_data) && data.ref_data[0]?.sopq_their;

        this.setState({
          submittedPaymentRef: paymentRef,
          refType: data.ref_type,
          refData: data.ref_data,
          refCust:data.cust,
          delAddr: data.del_addr || null,
          invAddr: data.inv_addr || null,
          quoteConverted: data.ref_type === "quote_complete",
          convertedRef: data.ref_type === "quote_complete" ? data.ref : '',
          convertedCustomer: data.ref_type === "quote_complete" ? data.customer : '',
          editableTheirRef: theirRef && theirRef.trim() !== '' ? theirRef : '',
          isLoading: false
        });

        formData2.append("ref", paymentRef);
        formData2.append("type", "paylink");
        formData2.append("info", "opened");
        formData2.append("text", getUrlParameterText());
        if (paymentRef !== "") {
          await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
            method: "POST",
            body: formData2,
          });
        }
      } else {
        alert(data.message || 'No result found.');
        this.setState({
          submittedPaymentRef: paymentRef,
          refType: '',
          refData: [],
          refCust: {},
          isLoading: false
        });
      }
    } catch (error) {
      console.error('Lookup failed:', error);
      alert('There was an error contacting the server.');
      this.setState({ isLoading: false, refData: [], refCust: {} });
    }
  };

  

  generate_request = async (cust, ref) => {
    const totalPence = this.state.refData.reduce((acc, item) => acc + (item.pbr_value_pence || 0), 0);
const totalPounds = (totalPence / 100).toFixed(2);

    if (totalPounds > 5000) {
      this.setState({ showOverLimitMessage: true });
      return;
    }
    
    
    const paymentRef=this.state.paymentRef

    const transactions = [{ type: "paylink", paymentRef }];
    const jsonString = JSON.stringify({ transactions });
    const base64Encoded = btoa(jsonString);

    const formData = new FormData();
    formData.append("ref", this.state.submittedPaymentRef);
    formData.append("type", "quote");
    formData.append("info", "worldpay");
    formData.append("text", this.state.editableTheirRef);

    await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });

    try {
      const response = await fetch(
        `https://payments.fhbrundle.co.uk/api?cmd=build_transaction&payref=${paymentRef || 'UNKNOWN'}`,
        {
          method: 'POST',
          body: base64Encoded,
        }
      );

      const data = await response.json();

      if (data.URL) {
        window.location = data.URL;
      } else {
        alert(data.reason || 'Payment request failed.');
      }
    } catch (err) {
      console.error(err);
      alert("There was a problem starting the payment process.");
    }
  };

  hasRestrictedProducts = () => {
    const { refData } = this.state;
    if (!Array.isArray(refData)) return false;

    return refData.some(item => item.product?.startsWith("CUT"));
  };

  openDeclineModal = async () => {
    const formData = new FormData();
    formData.append("ref", this.state.submittedPaymentRef);
    formData.append("type", "quote");
    formData.append("info", "decline_pressed");
    formData.append("text", "");

    await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
      method: "POST",
      body: formData,
    });

    this.setState({ showDeclineModal: true });
  };

  closeDeclineModal = () => {
    this.setState({ showDeclineModal: false, declineFeedback: '' });
  };

  submitDeclineFeedback = async () => {
    const { submittedPaymentRef, declineFeedback } = this.state;
    this.setState({ declined: true });
    this.closeDeclineModal();

    try {
      const formData = new FormData();
      formData.append("ref", submittedPaymentRef);
      formData.append("type", "quote");
      formData.append("info", "decline");
      formData.append("text", declineFeedback);

      await fetch("https://payments.fhbrundle.co.uk/api?cmd=check", {
        method: "POST",
        body: formData,
      });
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  render() {
    // You can reuse the same JSX layout as the original `Quotes` component
    // Just make sure it references the new state properties like `paymentRef`, `submittedPaymentRef`, etc.
// First calculate the total in pence
const refData = Array.isArray(this.state.refData) ? this.state.refData : [];
const hasPaymentData = refData.length > 0;
const totalPence = refData.reduce((acc, item) => acc + (item.pbr_value_pence || 0), 0);
const totalPounds = (totalPence / 100).toFixed(2);
    return (
     <div className="App app-shell paylink">
      <BrandHeader title="Payment request" subtitle="Secure invoice payment" />
      <PageHero
        title="Your payment request"
        description="Review the invoices and total below before continuing to our secure payment provider."
        compact
      />

      {/*               <form onSubmit={this.handleSubmit} style={{ margin: '20px' }}>
        <input
          type="text"
          name="paymentRef"
          value={this.state.paymentRef}
          onChange={this.handleChange}
          placeholder="Enter payment reference"
          className="form_input"
        />
        <div style={{ marginTop: '10px' }}>
          <button type="submit" className="lookup_link">
            Submit
          </button>
        </div>
      </form>*/}


{this.state.isLoading ? (
  <div className="payref-loading" role="status" aria-live="polite">
    <span className="payref-loading-spinner" aria-hidden="true" />
    <div>
      <strong>Loading your payment request</strong>
      <span>Retrieving the latest invoice details…</span>
    </div>
  </div>
) : hasPaymentData ? (
<>
<div className="quote_container">
        <div className="quote_summary_val">  
          <div className="quote_summary_values">
            <div className="payref-customer">
              <span className="summary_label">{this.state.refCust.name}</span>
              <strong>({this.state.refCust.code})</strong>
            </div>
          </div>
        </div>
</div>

<div className="item_container line-items-panel">
{refData.map((item, index) => {
  if (item.pbr_src !== 'invoice') {
    return <pre key={index}>{JSON.stringify(item)}</pre>;
  }

  const theirReference = item.sopig_their ?? item.sopih_their;
  const orderReference = item.sopig_ref ?? item.sopig_sopref ?? item.sopih_sopref;
  const trackingUrl = getTrackingUrl(item.tracking);

  return (
    <div key={index} className="payment_items ">
      <div className="product_card_content">
        <div className="invoice-card-field invoice-card-field--invoice">
          <span className="invoice-card-label">Invoice</span>
          <span className="invoice-card-value">{item.pbr_ref}</span>
        </div>
        <div className="invoice-card-field invoice-card-field--their-ref">
          <span className="invoice-card-label">Your reference</span>
          <span className="invoice-card-value">{theirReference || "—"}</span>
        </div>
        <div className="invoice-card-field invoice-card-field--order-ref">
          <span className="invoice-card-label">Order ref</span>
          <span className="invoice-card-value">{orderReference || "—"}</span>
        </div>
        <ol className="invoice-mini-timeline" aria-label={`Timeline for invoice ${item.pbr_ref}`}>
          <TimelineStep label="Entered" value={item.sopih_ord_date} />
          <TimelineStep label="Delivered" value={item.sopih_del_date} />
          <TimelineStep label="Invoiced" value={item.sopih_inv_date} />
        </ol>
        {trackingUrl ? (
          <a
            className="invoice-tracking-link"
            href={trackingUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Track invoice ${item.pbr_ref} in a new window`}
          >
            Track delivery <span aria-hidden="true">↗</span>
          </a>
        ) : (
          <span className="invoice-tracking-unavailable">No tracking</span>
        )}
        <div className="payment_item_bottom">
          <div className="pay_label">Value</div>
          <div className="pay_value">£{parseFloat(item.pbr_value_pounds).toFixed(2)}</div>
        </div>
      </div>
    </div>
  );
})}

</div>
<div className="quote_container">
 <div className="quote_summary_val">
    
    <div className="quote_summary_values">
      
      <div><span className="summary_label">Total (inc VAT):</span> <strong>£{parseFloat(totalPounds).toFixed(2)}</strong></div>
    </div>
  </div>


  
  </div>

  <div className="quote_container">
 <div className="quote_summary">
  <div className="quote_actions">
        

<button className="pay_button"   onClick={() => this.generate_request(this.state.ref )}>
Make payment 
</button>

</div>
</div>



</div>


{this.state.showOverLimitMessage && (
  <div className="limit_warning" style={{ marginTop: '20px', color: '#ffcc00', fontWeight: 'bold' }}>
    Orders over £5,000 cannot be performed online. Please call your sales office.
  </div>
)}
</>
) : null}
        {/* ... render logic using updated state names ... */}
        {/* You can copy/paste the JSX from your original render() and update state references accordingly */}
        {/* If you'd like me to update the entire JSX with the new variable names, let me know and I’ll complete that too. */}
      </div>
    );
  }
}
